import { Routes } from '@angular/router';
import { BuilderComponent } from './builder/builder.component';
import { ErrorPageComponent } from './error-page/error-page-component';
import { NotFoundComponent } from './not-found/not-found.component';
import { AccessDeniedComponent } from './access-denied/access-denied-component';

export const routes: Routes = [
    { path: '', redirectTo: '/builder', pathMatch: 'full' },  
    { path: 'builder', component: BuilderComponent },
    { path: 'access-denied', component: AccessDeniedComponent },
    { path: 'error', component: ErrorPageComponent },  
    { path: '**', component: NotFoundComponent } 
  ];